import React from "react";

import {
    doFlex,
    flexColumn,
    divW45,
    vertCenter,
    justifySpaceBetween,
    reasonsHead,
    reasonDiv,
    reasonsVar,
} from './main.module.scss'

const Reasons = ({reason, reasonDescription, children}) => {
    return (
        <div className={`${doFlex} ${vertCenter} ${justifySpaceBetween} ${reasonDiv}`}>
            <div className={`${divW45} ${reasonsVar}`}>
                {children}
            </div>
            <div className={`${flexColumn} ${divW45}`}>
                <h3 className={reasonsHead}>{reason}</h3>
                <p>{reasonDescription}</p>
            </div>
        </div>
    );
};

export default Reasons;